export default __webpack_public_path__ + "static/media/homepage-image3.3d68b228.png";